var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "list-Dialog",
          attrs: {
            "before-close": _vm.handleClose,
            visible: _vm.visible,
            title: "神券",
            width: "896px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _vm.visible
            ? _c("product-coupon-list", {
                attrs: { useType: _vm.useType },
                on: {
                  closeDialog: _vm.closeDialog,
                  getProductCouponId: _vm.getProductCouponId,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }